import toPriceValue from './../../useful/formatter'; // Bibliotecas
import './Weight.css'; // CSS

function  Weight({price, weight}) {
    return (
        <div className="weight">
            <span className="weight__weight-value">{weight}</span>

            <span className="weight__price">
                <span className="weight__price-coin">R$</span> {toPriceValue(price)}
            </span>
        </div>
    );
}

export default Weight;